if (!customElements.get('metta-moving-tiles')) {
  customElements.define('metta-moving-tiles', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.metta-moving-tiles__viewport');
      this.track = this.querySelector('.metta-moving-tiles__track');
      this.originals = Array.from(this.track.children);
      this.pause = this.querySelector('[data-tiles-pause]');
      this.previous = this.querySelector('[data-tiles-previous]');
      this.next = this.querySelector('[data-tiles-next]');
      this.media = matchMedia('(min-width: 960px) and (prefers-reduced-motion: no-preference)');
      this.controller = new AbortController();
      const on = (target, event, fn) => target.addEventListener(event, fn, {signal: this.controller.signal});
      on(this.media, 'change', () => this.configure());
      on(this, 'pointerenter', () => { this.hovered = true; });
      on(this, 'pointerleave', () => { this.hovered = false; });
      on(this.viewport, 'scroll', () => this.updateControls());
      on(this.pause, 'click', () => {
        this.paused = !this.paused;
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.setAttribute('aria-label', this.paused ? 'Halda hreyfingu áfram' : 'Gera hlé á hreyfingu');
        this.pause.textContent = this.paused ? '▷' : 'Ⅱ';
      });
      const step = direction => {
        const distance = this.originals[0]?.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        if (this.loopWidth) this.viewport.scrollLeft = ((this.viewport.scrollLeft + direction * distance) % this.loopWidth + this.loopWidth) % this.loopWidth;
        else this.viewport.scrollBy({left: direction * distance, behavior: this.media.matches ? 'smooth' : 'auto'});
      };
      on(this.previous, 'click', () => step(-1));
      on(this.next, 'click', () => step(1));
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.viewport);
      this.configure();
      const tick = time => {
        const elapsed = Math.min(time - (this.lastTime || time), 50);
        this.lastTime = time;
        if (this.loopWidth && !this.paused && !this.hovered && !this.matches(':focus-within') && !document.hidden) {
          // Drift right to left; wrap within the duplicated row without a visible jump.
          this.travel = (this.travel || 0) + elapsed * 0.024;
          const pixels = Math.floor(this.travel);
          this.travel -= pixels;
          let position = this.viewport.scrollLeft + pixels;
          if (position >= this.loopWidth) position -= this.loopWidth;
          this.viewport.scrollLeft = position;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    configure() {
      this.track.querySelectorAll('[data-tile-clone]').forEach(item => item.remove());
      this.loopWidth = 0;
      if (this.media.matches && this.originals.length > 1) {
        this.originals.forEach(item => {
          const clone = item.cloneNode(true);
          clone.dataset.tileClone = '';
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach(el => {
            el.removeAttribute('id');
            el.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a,button,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        });
      }
      this.viewport.scrollLeft = 0;
      this.measure();
    }
    measure() {
      const clone = this.track.querySelector('[data-tile-clone]');
      this.loopWidth = clone ? clone.getBoundingClientRect().left - this.originals[0].getBoundingClientRect().left : 0;
      this.updateControls();
    }
    updateControls() {
      this.previous.disabled = !this.loopWidth && this.viewport.scrollLeft <= 1;
      this.next.disabled = !this.loopWidth && this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 1;
      this.pause.hidden = !this.loopWidth;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller.abort();
      this.resize.disconnect();
      this.track.querySelectorAll('[data-tile-clone]').forEach(item => item.remove());
    }
  });
}
